module.exports = __webpack_public_path__ + "static/media/refrigeratorQuestion.dd2c3596.png";